import React, { useState } from 'react';
import {
  Modal,
  Button,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import qs from 'qs';

import { delay, getErrorMessage } from '../../../../../utils/helper';
import {
  bulkRefillOrders,
} from '../../../../../services/endpoints/orders';

import Loader from '../../../../../components/Loaders/Loader';
import ModalConfirm from '../../../../../components/Modal/ConfirmLayouts';

const MassRequestRefillModal = ({ values, onHide, onSubmit }) => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({
    init: false,
    success: false,
    changeStatusTo: null,
  })
  const { success } = modalData;

  const queryString = qs.parse(window.location.search.slice(1));

  const onSubmitForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await bulkRefillOrders(queryString, {
        orders: values,
      });
      setModalData((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit(response.data)
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setLoading(false);
    }
  };

  return (
    <ModalConfirm.Wrapper>
      <Modal.Body>
        <ModalConfirm.TitleDescriptionWrapper>
          {error ? <div className="alert alert-danger">{error}</div> : null}
          {isLoading ? <Loader success={success} /> : null }
          <ModalConfirm.Title>
            Request refill
          </ModalConfirm.Title>
          <ModalConfirm.Description>
            <div>
              Are you sure you want to refill
              {' '}
              <b>{values.length}</b>
              {' '}
              selected orders?
            </div>
          </ModalConfirm.Description>
        </ModalConfirm.TitleDescriptionWrapper>
        <ModalConfirm.Actions>
          <Button
            type="button"
            bsStyle="primary"
            disabled={isLoading}
            onClick={onSubmitForm}
          >
            <span>Change</span>
          </Button>
          <Button
            disabled={isLoading}
            onClick={onHide}
          >
            <span>Close</span>
          </Button>
        </ModalConfirm.Actions>
      </Modal.Body>
    </ModalConfirm.Wrapper>
  );
};

MassRequestRefillModal.propTypes = {
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
  values: PropTypes.array,
};

export default MassRequestRefillModal;
